import { FlowsProjectRoleBindingView } from "shared/Flows/Projects/useFlowsProject/types";
import { useBulkFlowsProjectRoleBindingDelete } from "shared/Flows/Projects/useFlowsProjectRoleBindingDelete";

import { FlowsProjectRolesBulkActions, FlowsProjectRolesBulkActionItem } from "../types";

const useUnassignFlowsProjectRolesBulkAction = (): FlowsProjectRolesBulkActionItem => {
  const [deleteFlowsProjectRoleBinding] = useBulkFlowsProjectRoleBindingDelete();

  return {
    key: FlowsProjectRolesBulkActions.Unassign,
    title: "Unassign",
    resultTitle: "Unassign roles results",
    // The Flows projects area is account-admin only, so the action always applies.
    condition: () => ({ result: true }),
    mutation: (roleBinding: FlowsProjectRoleBindingView) =>
      deleteFlowsProjectRoleBinding({ id: roleBinding.id }),
  };
};

export default useUnassignFlowsProjectRolesBulkAction;
